import React, {useEffect, useState} from 'react'
import {
    Button,
    CircularProgress,
    Stack,
    Typography,
} from "@mui/material"
import {useProjectData} from "../../hooks/useProjectData"
import ProjectPageHeader from "../layouts/ProjectPageHeader"
import {useNavigate} from "react-router-dom"
import CustomModelsTable, {CustomModelTableColumn} from "../custommodels/CustomModelsTable"
import {AnyCustomModelJson} from "../../api/json/CustomModelJson"
import {CustomModelRequests} from "../../api/requests/CustomModelRequests"
import ApiError from "../../api/ApiError"
import CustomModelColumnMenu from "../custommodels/CustomModelColumnMenu"
import ErrorMessage from "../error/ErrorMessage"
import AddIcon from "@mui/icons-material/Add"
import {useBreadcrumbs} from "../layouts/Nav/BreadcrumbsProvider"
import {NAV_LABELS} from "../../library/NavLabels"

function CustomModelsPage() {
    useBreadcrumbs([{label: NAV_LABELS.MODELS}])
    const {id, project} = useProjectData()

    const [customModels, setCustomModels] = useState<AnyCustomModelJson[]>()
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState<ApiError>()

    const [columns, setColumns] = useState<CustomModelTableColumn[]>(["Score", "Platform", "Model", "Epochs", "Template", "Training Rows", "Created", "Status"])

    const navigate = useNavigate()

    useEffect(() => {
        if (loading || customModels) return
        loadCustomModels()
    }, [project])

    const loadCustomModels = () => {
        setLoading(true)
        CustomModelRequests.list(id)
            .then(response => {
                setCustomModels(response.content)
                setError(undefined)
            })
            .catch(setError)
            .finally(() => setLoading(false))
    }

    if (!project) {
        return <CircularProgress/>
    }

    return (
        <>
            <ProjectPageHeader
                showFab
                pageTitle="Custom Models"
                replaceFab={
                    <Button variant="contained"
                            startIcon={<AddIcon/>}
                            onClick={() => navigate(`/projects/${id}/custom-models/train`)}
                    >
                        Create
                    </Button>
                }
            />

            {loading && <CircularProgress/>}

            {error && <ErrorMessage error={error} sx={{mt: 2}}/>}

            {customModels && customModels.length > 0 &&
                <Stack spacing={2}>
                    <Stack direction="row" alignItems="center">
                        <CustomModelColumnMenu columns={columns} onChange={setColumns}/>
                    </Stack>
                    <CustomModelsTable customModels={customModels} columns={columns} reload={loadCustomModels}/>
                </Stack>
            }

            {customModels && customModels.length === 0 && !loading &&
                <Stack spacing={2} alignItems="center" sx={{py: 8}}>
                    <Typography variant="body1" color="text.secondary">
                        No custom models yet.
                    </Typography>
                    <Button variant="outlined"
                            startIcon={<AddIcon/>}
                            onClick={() => navigate(`/projects/${id}/custom-models/train`)}
                    >
                        Create your first custom model
                    </Button>
                </Stack>
            }
        </>
    )
}

export default CustomModelsPage
